// extracted by mini-css-extract-plugin
export default {"message":"span-message_message__ir3aG","boldFont":"span-message_boldFont__yQvW0","lowerCase":"span-message_lowerCase__1fHVQ"};